// api/checkRedirectUrl.ts
import { registerQuery } from "@adornis/baseql/metadata/register.js";
import { getRawCollection } from "@adornis/baseql/server/collections.js";
import { CheckRedirectResult } from "../db/CheckRedirectResult.js";
import { Redirect } from "../db/Redirect.js";
var checkRedirectUrl = registerQuery({
  type: () => CheckRedirectResult,
  operationName: "checkRedirectUrl",
  resolve: (pathToCheck, staticRedirects, useDatabase) => {
    return async (gqlFields) => {
      let dynamicRedirects = [];
      if (useDatabase) {
        const rawRedirectCollection = await getRawCollection(Redirect._collectionName);
        const redirects2 = await rawRedirectCollection.find({}).toArray();
        if (redirects2)
          dynamicRedirects.push(...redirects2);
      }
      const redirects = [...staticRedirects, ...dynamicRedirects];
      for (const redirect of redirects) {
        try {
          const pattern = new URLPattern({ pathname: redirect.from });
          const match = pattern.exec({ pathname: pathToCheck });
          if (match) {
            let newPath = redirect.to;
            Object.entries(match.pathname.groups).forEach(([key, value]) => {
              if (typeof value === "string") {
                newPath = newPath.replace(`:${key}`, encodeURIComponent(value));
              }
            });
            return new CheckRedirectResult({
              redirect,
              redirectURL: newPath
            });
          }
        } catch (error) {
          continue;
        }
      }
    };
  },
  params: [
    { name: "pathToCheck", type: () => String },
    { name: "staticRedirects", type: () => [Redirect] },
    { name: "useDatabase", type: () => Boolean }
  ]
});
export {
  checkRedirectUrl
};
